import Slider from "react-slick";
import Styles from "./Slider.module.scss"
import banner1 from "../../assets/images/index/Banner/廣博巴士-肯兆固5號.jpg";
import banner2 from "../../assets/images/index/Banner/汽車保養.jpg";
import classNames from "classnames";

const SliderConponent = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };
  const banners = [
    { id: 1, image: banner1 },
    { id: 2, image: banner2 },
  ];
  return (
    <div className={classNames(Styles.slider)}>
      <Slider {...settings}>
        {banners.map((banner) => (
          <div key={banner.id}>
            <img
              src={banner.image}
              alt={`Banner ${banner.id}`}
              className={classNames(Styles.slider__img)}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SliderConponent;
